/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 从产品设备/OSM/component/omm_infra/conf/product_ini/omm/product.ini [DM_FEATURE_CONFIG]中读出的特性配置
 * 用于解耦型号与特性之间的关系
 * 需要在业务代码中判断是否为有效值，并且写一个兜底值判断，避免获取配置文件失败导致页面功能失效
 */
const _FeatureConfig = {
    /**
     * pool推荐配额最小值(TB)（使用ProductConfig里的MinLogicCapacitySpecInDisklessDomain替换）
     */
    MinQuota: undefined,
    /**
     * 是否支持卷迁移VOLUME MOVE(2910,二级存储,微存储不支持)
     */
    IsSupportVolumeMove: undefined,
    /**
     * 是否支持FCV精准跳转(2910)
     */
    IsSupportFCVLocation: undefined,
    /**
     * V6-dashboard监控NAS性能指标增强开关是否打开(2910,二级存储,微存储不支持)
     */
    IsSupportDashboardIndicatorEnhance: undefined,
    /**
     * 是否默认支持数据缩减(2910)
     */
    IsSupportDataReductionWithoutLic: undefined,
    /**
     * 是否支持数据缩减包含RAID版(微存储)
     */
    IsSupportDataReductionRaid: undefined,
    /**
     * 是否支持NFS客户端(2910,微存储不支持)
     */
    IsSupportNFSClient: undefined,
    /**
     * 是否支持RAID10(2910,二级存储不支持)
     */
    IsSupportRAID10: undefined,
    /**
     * 是否支持功耗查看(2910不支持)
     */
    IsSupportPowerView: undefined,
    /**
     * 是否支持性能预测(2910,微存储不支持)
     */
    IsSupportMonitorForecast: undefined,
    /**
     * 是否支持eService(2910不支持)
     */
    IsSupportEService: undefined,
    /**
     * 是否默认支持电源能耗信息查询(2910)
     */
    IsSupportQueryPowerSupply: undefined,
    /**
     * 租户系统登录是否支持物理端口(2910不支持)
     */
    IsSupportPhysicalPort: undefined,
    /**
     * 是否支持FC端口、FC链路、FC启动器(2910,微存储直通不支持)
     */
    IsSupportFC: undefined,
    /**
     * 是否支持NVMe Over RoCE网络和端口(2910,入门级,二级存储不支持)
     */
    IsSupportNVMEOverRoCENetWorkAndLif: undefined,
    /**
     * 是否支持NVMe Over RoCE启动器(2910,入门级不支持)
     */
    IsSupportNVMEOverRoCEInitiator: undefined,
    /**
     * 是否显示高端k系列产品型号定制图片(18800_832,8800_920,18500K_840)
     */
    IsSupportKseriesImg: undefined,
    /**
     * 是否支持SAS端口(微存储全闪不支持)
     */
    IsSupportSASPort: undefined,
    /**
     * 是否支持namespace缓存策略(微存储混闪)
     */
    IsSupportNameSpaceCache: undefined,
    /**
     * 是否支持缓存策略为性能层时有高危提示
     */
    IsSupportCachePolicyAlarm: undefined,
    /**
     * 是否支持绑定端口创建(2910不支持)
     */
    IsSupportCreateBondPort: undefined,
    /**
     * 首页是否屏蔽欢迎使用DeviceManager窗口(二级存储A)
     */
    IsHideWhatNew: undefined,
    /**
     * 是否2910高级搜索快速入门(2910支持)
     */
    Is2910GlobalSearchQuickStart: undefined,
    /**
     * 是否查询绑定端口只查主机端口(2910支持)
     */
    IsQueryBondPortOnlyMatchHostPort: undefined,
    /**
     * 逻辑端口是否显示归属站点(二级存储X,2910,微存储不支持)
     */
    IsShowLIFHomeSite: undefined,
    /**
     * 是否支持二维码展示(2910不支持)
     */
    IsSupportQrCode: undefined,
    /**
     * 是否支持DME IQ(2910不支持)
     */
    IsSupportDMEIQ: undefined,
    /**
     * 容量层热备盘校验是否需要预留盘做重构(新融合,除2910)
     */
    IsNeedReservedDisksForReconstruction: undefined,
    /**
     * 是否支持独享性能层(新融合,除2910)
     */
    IsSupportUniquePerformanceLayer: undefined,
    /**
     * 是否支持SmartCache(新融合,二级存储,微存储不支持)
     */
    IsSupportSmartCache: undefined,
    /**
     * 系统升级目标版本文本格式示例(默认dorado格式,可选Xseries,micro)
     */
    SystemUpgradeUploadTargetExampleI18n: undefined,
    /**
     * 是否支持SmartMigration(微存储不支持)
     */
    IsSupportSmartMigration: undefined,
    /**
     * 租户视图首页是否显示双活pair(2910不显示)
     */
    IsShowHyperMetroPairInVstoreHome: undefined,
    /**
     * 是否支持HyperMetro(二级存储,微存储不支持)
     */
    IsSupportHyperMetro: undefined,
    /**
     * 是否展示存储集群下电和重启按钮(2910不支持)
     */
    IsShowDeviceRestartAndShutDownButton: undefined,
    /**
     * 是否支持OTA升级(2910不支持)
     */
    IsSupportOTAUpgrade: undefined,
    /**
     * 是否展示智能告警修复(2910、微存储不支持)
     */
    IsShowIntelligentAlarmHandling: undefined,
    /**
     * 是否显示端口绑定类型(2910支持)
     */
    IsShowBondPortType: undefined,
    /**
     * 是否支持BGP类型的LIF口(2910、二级存储、微存储不支持)
     */
    IsSupportBGPLif: undefined,
    /**
     * 是否计算型外观(2910,5910支持)
     */
    IsCalculatedAppearance: undefined,
    /**
     * 是否有虚拟硬盘抽屉(2910,5910支持)
     */
    HasFakeDiskDrawer: undefined,
    /**
     * 是否是dbStore一体机形态(5910支持)
     */
    IsDbStoreIntegratedMachine: undefined,
    /**
     * 是否2910首页白牌图片(2910支持)
     */
    Is2910HomeOemPicture: undefined,
    /**
     * 是否支持票据续期URL(2910不支持)
     */
    IsSupportTouchUrl: undefined,
    /**
     * 是否显示绑定模式(2910支持)
     */
    IsShowBondMode: undefined,
    /**
     * 是否2910硬件类型(2910支持)
     */
    Is2910HardwareType: undefined,
    /**
     * 是否支持DSCP信任模式(2910不支持)
     */
    IsSupportDscpTrustMode: undefined,
    /**
     * 是否取消映射会导致业务中断(2910支持)
     */
    IsCancelMapWillAlertBusinessInterruptionInPromptMsg: undefined,
    /**
     * 启动器ID是否是Iqn(2910支持)
     */
    IsInitiatorIdToBeIqn: undefined,
    /**
     * 是否支持跳转新手引导页(微存储,二级存储X不支持)
     */
    IsSupportOpenQuickStart: undefined,
    /**
     * 是否轮询质检信息(2910不支持)
     */
    IsQualityInspectNeeded: undefined,
    /**
     * 无容量层硬盘时,存储池每个引擎的性能层硬盘（即SSD盘）起配盘数(使用SWITCH.ts里的MinSsdDiskNumberInDisklessDomain代替)
     */
    MinPerformanceDiskNumOfEachEngine: undefined,
    /**
     * 容量层热备策略每个引擎最小非热备盘数量(2910为4)
     */
    MinNotHotSpareDiskNumOfEachEngine: undefined,
    /**
     * 每个引擎最少选择硬盘数量(2910为4)
     */
    MinDiskNumOfEachEngine: undefined,
    /**
     * 是否支持容量层默认热备策略选项(2910)
     */
    IsShowDefaultFlashLayerHotSpareOption: undefined,
    /**
     * 是否支持NAS双活特性(2910,二级存储，微存储不支持)
     */
    IsSupportNASHyperMetro: undefined,
    /**
     * 是否显示NAS的所属远程复制一致性组(二级存储不显示)
     */
    IsShowBelongToRepCg: undefined,
    /**
     * LUN和文件系统是否支持二级存储默认应用类型(二级存储)
     */
    IsShowDefaultWorkloadTypeForOceanProtect: undefined,
    /**
     * 是否支持eDevLUN(影响takeOverLunWwn)(二级存储不支持)
     */
    IsSupportEDevLun: undefined,
    /**
     * 文件系统获取所有应用类型时以poolVersion参数名下发(二级存储)
     */
    IsParamNameAsPoolVersionWhenGetWorkloadTypesInFS: undefined,
    /**
     * 文件系统应用类型下是否显示变长分片平均大小(二级存储)
     */
    IsShowVariableSegmentInFSWorkloadType: undefined,
    /**
     * 文件系统是否需要先查询pool再根据pool version查询应用类型(二级存储)
     */
    IsQueryPoolBeforeQueryWorkloadTypesInFS: undefined,
    /**
     * WORM是否屏蔽最小最大保护期(二级存储)
     */
    IsDisableMinMaxProtectInWORM: undefined,
    /**
     * CloudTier支持迁移的文件大小范围最小值是否显示为64KB(二级存储)
     */
    IsCloudTierTaskFileSizeMinValue64KB: undefined,
    /**
     * 是否支持租户服务(微存储不支持)
     */
    IsSupportVStoreService: undefined,
    /**
     * 是否屏蔽报表导出(微存储)
     */
    IsHideDataExport: undefined,
    /**
     * 是否屏蔽PMS(微存储)
     */
    IsHidePms: undefined,
    /**
     * 是否屏蔽外部存储(微存储)
     */
    IsHideExternalStorage: undefined,
    /**
     * 显示外部存储是否需要remote_device_R权限以及SmartVirtualization License（二级存储X）
     */
    IsNeedPermissionAndLicenseBeforeShowExternalStorage: undefined,
    /**
     * 是否将lun术语替换为namespace(微存储)
     */
    IsReplaceStrLunWithNamespace: undefined,
    /**
     * 是否支持Vxlan(dorado,新融合)
     */
    IsSupportVxlan: undefined,
    /**
     * 是否支持日文(dorado,新融合)
     */
    IsSupportJaLan: undefined,
    /**
     * 是否支持SMBODX(dorado,新融合)
     */
    IsSupportSMBODX: undefined,
    /**
     * 是否支持性能层(新融合,2910,微存储混闪)
     */
    IsSupportSmartPool: undefined,
    /**
     * 在支持NAS情况下是否支持DataTurbo(二级存储)
     */
    IsSupportDataTurboWhenNASIsSupported: undefined,
    /**
     * 在支持NAS情况下是否支持DPC特性(A800)
     */
    IsSupportDpcWhenNASIsSupported: undefined,
    /**
     * 创建或者扩容的存储池物理接入容量不能超过0.75PB(二级存储)
     */
    IsLimitCapacityWhenCreateStoragePool: undefined,
    /**
     * 是否直接支持DataTurbo逻辑端口(微存储)
     */
    IsSupportDataTurboLif: undefined,
    /**
     * 是否支持DataTurboOverRoCE逻辑端口
     */
    IsSupportDataTurboOverRoCELif: undefined,
    /**
     * 扩容是否下发容量层热备(2910不支持)
     */
    HasPostSSDHotSpareStrategy: undefined,
    /**
     * 是否支持双活租户Pair(2910,微存储,二级存储不支持)
     */
    IsSupportVstoreHyperMetroPair: undefined,
    /**
     * 是否展示级联端口(2910不支持)
     */
    IsShowExpPortType: undefined,
    /**
     * 是否展示维护端口(2910不支持)
     */
    IsShowMaintenancePortType: undefined,
    /**
     * 是否展示虚拟交换机(2910支持)
     */
    IsShowVSwitch: undefined,
    /**
     * 是否支持扩容独享性能层(2910支持)
     */
    IsSupportExpandExclusivePerformanceLayer: undefined,
    /**
     * 是否支持创建存储池(2910不支持)
     */
    IsEnableStoragePoolCreation: undefined,
    /**
     * 是否支持修改应用存储池(二级存储不支持)
     */
    IsSupportModifyAppStoragePool: undefined,
    /**
     * 是否显示CRU工具以及更换教程(A系列，2910，高端型号（除6800 V6，6810，Dorado 8000 V6，Dorado 6800，Dorado 8000）不支持)
     */
    IsShowCRU: undefined,
    /**
     * 硬件设备图中是否需要适配入门级存储的控制框位置、部件尺寸(入门级存储)
     */
    IsNeedAdaptProdEntryControl: undefined,
    /**
     * 是否展示信息中心(D2000,二级存储,2910不支持)
     */
    IsShowSelfService: undefined,
    /**
     * 是否前端屏蔽除智能告警之外的smartGUI特性(二级存储)
     */
    IsHideSmartGUIWithoutAlarmInDM: undefined,
    /**
     * 是否支持系统级smartQos特性(微存储不支持)
     */
    IsSupportSystemSmartQos: undefined,
    /**
     * 是否支持容器存储(入门级,2910,二级存储,微存储不支持)
     */
    IsSupportContainerStorage: undefined,
    /**
     * 是否支持vvol(二级存储,微存储不支持)
     */
    IsSupportVVOL: undefined,
    /**
     * 是否展示二级存储对应菜单目录以及入口(二级存储)
     */
    IsShowMenuItemsForOceanProtect: undefined,
    /**
     * 将启动器添加到主机时是否显示旧版本的确认提示(二级存储,2910,微存储)
     */
    IsShowOldConfirmTipsWhenAddInitiator: undefined,
    /**
     * 是否显示数据保护-文件系统-双活pair(二级存储，2910不支持)
     */
    IsShowProtectFSHyperMetro: undefined,
    /**
     * 是否显示数据保护-多租户,双活域(二级存储X系列，微存储不支持)
     */
    IsShowProtectVstore: undefined,
    /**
     * 是否支持远程复制租户pair(二级存储系列，微存储不支持)
     */
    IsSupportRemoteRepPairVstore: undefined,
    /**
     * 是否支持以太网端口(微存储不支持)
     */
    IsSupportEthPort: undefined,
    /**
     * 是否支持后端以太网端口(2910,微存储不支持)
     */
    IsSupportEthBackPort: undefined,
    /**
     * 是否判断以太网端口上的绑定名称(2910,微存储不需要)
     */
    ShouldConcernEthBondName: undefined,
    /**
     * 是否支持打开登录页视频开关(2910,5910不支持)
     */
    IsSupportLoginVideoSwitch: undefined,
    /**
     * 是否支持iscsi(微存储直通不支持)
     */
    IsSupportISCSI: undefined,
    /**
     * 是否支持设置主机访问模式（微存储直通和二级存储X系列不支持）
     */
    IsSupportHostAccessMode: undefined,
    /**
     * 是否支持设置主机双活优选路径（微存储和二级存储X系列不支持）
     */
    IsSupportPreferredPath: undefined,
    /**
     * LUN映射保持主机LUN ID一致（微存储和二级存储X系列不支持）
     */
    IsSupportForceHostLunIdSame: undefined,
    /**
     * 支持环形3DC（二级存储X系列不支持）
     */
    IsSupportDrStar: undefined,
    /**
     * 远程复制是否支持同步复制，同异步互转（二级存储X不支持）
     */
    IsSupportAsyncSwitch: undefined,
    /**
     * 异步复制是否显示待拷贝数据量统计（二级存储不支持）
     */
    IsShowSyncDataInReplicationDetails: undefined,
    /**
     * NAS远程复制是否显示待拷贝数据量统计（微存储和A800不支持）
     */
    IsShowSyncDataInRepDetailsForNas: undefined,
    /**
     * 支持防勒索（二级存储其他系列不支持）
     */
    IsSupportHyperDetect: undefined,
    /**
     * 有数据备份license时是否支持防勒索(二级存储不支持)
     */
    IsSupportHyperDetectWhenHasDataBackUpCapacityLicense: undefined,
    /**
     * 支持容量层（5510S不支持）
     */
    IsSupportCapacityLayer: undefined,
    /**
     * 支持框级冗余（Dorado低端型号、二级存储、微存储、新融合低端型号不支持）
     */
    IsSupportEnclosureLevel: undefined,
    /**
     * License页面支持显示已使用容量(18510_837,18810_838,18500K_840)
     */
    IsSupportLicenseUsage: undefined,
    /**
     * 支持配置空间回收策略（二级存储支持）
     */
    IsSupportIdleRecycle: undefined,
    /**
     * 支持高级搜索（二级存储不支持）
     */
    IsSupportAdvanceInfigo: undefined,
    /**
     * 是否支持NFS4.0(二级存储不支持)
     */
    IsSupportNFSV4: undefined,
    /**
     * 用户默认登录方式是否支持带内（二级存储，微存储不支持）
     */
    IsSupportINBANDInRoleLoginMode: undefined,
    /**
     * 逻辑端口是否屏蔽客户端角色（2910,微存储)
     */
    IsHideClientRoleInLifPort: undefined,
    /**
     * 逻辑端口是否屏蔽Vtep角色（2910,二级存储,微存储）
     */
    IsHideVtepRoleInLifPort: undefined,
    /**
     * 逻辑端口是否屏蔽健康检查角色（2910，二级存储）
     */
    IsHideHealthCheckRoleInLifPort: undefined,
    /**
     * 逻辑端口是否仅支持数据角色类型（微存储）
     */
    IsOnlySupportDataRoleInLifPort: undefined,
    /**
     * 存储池是否显示压缩模式（二级存储，V3_6000_806）
     */
    IsShowCompressLevel: undefined,
    /**
     * 文件系统是否显示应用请求大小（二级存储不显示）
     */
    IsShowRequestSizeStrInFS: undefined,
    /**
     * 文件系统是否显示归属控制器（二级存储）
     */
    IsShowOwnedControllerInFS: undefined,
    /**
     * 存储池是否屏蔽配置定时数据保护自动删除阈值（微存储）
     */
    IsHideProtectCapacityThreshold: undefined,
    /**
     * 即将耗尽容量告警阈值是否显示帮助提示（二级存储）
     */
    IsShowHelpContentOfUsedUpAlarmThreshold: undefined,
    /**
     * 是否支持最大RAID成员盘数（二级存储，2910不支持）
     */
    IsSupportMaxRaidMemberNumber: undefined,
    /**
     * 支持通道LUN（二级存储支持）
     */
    IsSupportChannelLun: undefined,
    /**
     * 联机帮助链接为高端型号链接（高端型号支持）
     */
    IsHighProdHelp: undefined,
    /**
     * 是否展示高端型号首页（高端型号支持）
     */
    IsShowHighHome: undefined,
    /**
     * 是否屏蔽高端型号首页概览（A800支持）
     */
    IsShowHighHomeAndHideDeviceOverView: undefined,
    /**
     * 是否不支持快速升级（高端型号不支持）
     */
    IsNotSupportFastUpgrade: undefined,
    /**
     * 是否过滤物理形态为盘的（高端型号过滤）
     */
    IsFilterDiskMorpha: undefined,
    /**
     * 是否支持控制框选项（高端型号支持）
     */
    IsSupportCtrlEnclosureOptions: undefined,
    /**
     * 是否为高端型号快速入门列表项（高端型号支持）
     */
    IsHighProdQuickStartList: undefined,
    /**
     * 是否展示高端型号高级搜索展示项（高端型号展示）
     */
    IsShowHighProdGlobalSearchShowList: undefined,
    /**
     * 是否展示顶部菜单高端型号展示项（高端型号展示）
     */
    IsShowHeaderHighProdList: undefined,
    /**
     * 是否支持SmartQos不依赖license(微存储)
     */
    IsSupportSmartQosNoNeedLicense: undefined,
    /**
     * 是否屏蔽机柜与级联版(微存储)
     */
    IsHideCabinetAndExpansion: undefined,
    /**
     * 是否屏蔽数据保护相关(微存储屏蔽数据保护容量、页签、查询双活复制类请求等)
     */
    IsHideProtection: undefined,
    /**
     * 是否屏蔽Iscsi启动器名称(微存储)
     */
    IsHideIscsiInitiatorName: undefined,
    /**
     * 是否屏蔽LUN表格业务类型列(微存储LUN表格屏蔽：功能类型、使用类型、接管类型、WWN相关等)
     */
    IsHideLunTableBusinessColumnDef: undefined,
    /**
     * 是否支持模式和介质类型(微存储)
     */
    IsSupportOceanMicroModeAndMediaType: undefined,
    /**
     * 是否屏蔽可得容量(微存储)
     */
    IsHideGuaranteedCapacity: undefined,
    /**
     * 是否屏蔽Thick Lun(微存储)
     */
    IsHideThickLun: undefined,
    /**
     * 是否只支持主机linux操作系统(微存储)
     */
    IsSupportOnlyHostLinuxSystem: undefined,
    /**
     * 是否支持微存储设备图(微存储)
     */
    IsSupportOceanMicroHardwareDevice: undefined,
    /**
     * 是否屏蔽回收站父对象(微存储)
     */
    IsHideRecycleBinParentObj: undefined,
    /**
     * 是否屏蔽以太网端口待恢复运行状态(微存储)
     */
    IsHideEthPortRecoverdRunningStatus: undefined,
    /**
     * 是否支持逻辑类型列表(微存储)
     */
    IsSupportOceanMicroLogicTypeOpt: undefined,
    /**
     * 是否屏蔽DNS zone(微存储)
     */
    IsHideDnsZone: undefined,
    /**
     * 是否支持逻辑端口帮助(微存储)
     */
    IsSupportOceanMicroLifHelpLink: undefined,
    /**
     * 是否支持创建以太网VLAN过滤roce端口(微存储)
     */
    IsSupportOceanMicroOnlySupportEthVlan: undefined,
    /**
     * 是否屏蔽逻辑端口角色列过滤项(微存储)
     */
    IsHideLifTableRoleFilterOpt: undefined,
    /**
     * 是否屏蔽FC网络的立即数(微存储)
     */
    IsHideFcImmediateData: undefined,
    /**
     * 是否屏蔽FC网络的端口协议(微存储)
     */
    IsHideFcProtocolType: undefined,
    /**
     * 是否屏蔽逻辑端口的当前端口(微存储)
     */
    IsHideLogicPortCurrentPort: undefined,
    /**
     * 是否屏蔽LUN容量告警阈值(微存储)
     */
    IsHideLunAlarmThreshold: undefined,
    /**
     * 是否屏蔽文件系统路由(微存储)
     */
    IsHideNasRoute: undefined,
    /**
     * 是否屏蔽首页容量趋势(微存储)
     */
    IsHideCapacityTrend: undefined,
    /**
     * 是否屏蔽按节点导出日志(微存储)
     */
    IsHideExportLogByNode: undefined,
    /**
     * 是否屏蔽SmartGui(微存储，2910)
     */
    IsHideSmartGui: undefined,
    /**
     * 是否支持显示LUN应用类型“推荐使用场景”（微存储）
     */
    IsSupportRecommendedScenario: undefined,
    /**
     * 是否屏蔽设备图“修改机框信息”按钮（微存储）
     */
    IsHideModifyEnclosureInfo: undefined,
    /**
     * 是否屏蔽拓扑图硬盘利用率（微存储）
     */
    IsHideTopoDiskUsage: undefined,
    /**
     * 是否支持SmartMobility（微存储不支持）
     */
    IsSupportSmartMobility: undefined,
    /**
     *  是否融合存储重删压缩专享版（新融合,2910且有license）
     */
    IsSupportDataReductionCoverageStor: undefined,
    /**
     * 是否QLC型号外观（5310_Q,5510_Q)
     */
    IsQLCAppearance: undefined,
    /**
     *  是否新融合外观（新融合,2910）
     */
    IsCoverageStorAppearance: undefined,
    /**
     *  是否微存储外观（微存储）
     */
    IsOceanDiskAppearance: undefined,
    /**
     *  是否新融合应展示应用类型（新融合,2910）
     */
    IsCoverageStorWorkloadType: undefined,
    /**
     * 是否屏蔽访问控制防火墙（2910，微存储）
     */
    IsHideAccessControlFirewall: undefined,
    /**
     * 是否屏蔽性能层扩容自动分配占比（2910）
     */
    IsHideSmartPoolAutoExpand: undefined,
    /**
     * 扩容存储池，不过滤非加密盘（2910）
     */
    IsSkipFilterNonEncrypted: undefined,
    /**
     * 是否屏蔽IPsec（2910，微存储）
     */
    IsHideIpsec: undefined,
    /**
     * NVMe_Over_RoCE协议，端口类型默认显示为VLAN（2910）
     */
    IsPortTypeDefaultVlan: undefined,
    /**
     * 是否显示dorado k系列产品型号定制图片(18800_832,18800_920)
     */
    ShowAdvancedDoradoKSeriesHomeImg: undefined,
    /**
     * QLC型号控制数据缩减显示(区别其他新融合型号和Dorado保持一致)
     */
    IsSupportPelagodbQlcDataReductionDisplay: undefined,
    /**
     * 是否显示NVMe SubSystem Nqn（Dorado和新融合）
     */
    IsShowNvmeSubsystemNqn: undefined,
    /**
     * 是否支持虚拟机(微存储)
     */
    IsSupportVM: undefined,
    /**
     * 是否支持AP LUN/StoragePool
     */
    IsSupportDataAffinityMode: undefined,
    /**
     * 是否隐藏cifs协议
     */
    IsHideCifsLif: undefined,
    /**
     * 是否隐藏nfs+cifs协议
     */
    IsHideNfsAndCifsLif: undefined,
    /**
     * 是否隐藏iscsi协议
     */
    IsHideIscsiLif: undefined,
    /**
     * 是否隐藏NVMEOverRoCE协议
     */
    IsHideNVMEOverRoCELif: undefined,
};

export const FeatureConfig = { ..._FeatureConfig };

Object.keys(FeatureConfig).forEach((key: string) => {
    if (FeatureConfig[key] !== undefined && /^Is|^Has|^Should/.test(key)) {
        Object.defineProperty(FeatureConfig, key, {
            get: (): boolean => Boolean(_FeatureConfig[key]),
        });
    }
});
